/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssertionVM { 
    id?: number | null;
    recipientEmail?: string | null;
    issuedOn?: string | null;
    expires?: string | null;
    fullName?: string | null;
    phone?: string | null;
    phoneJson?: string | null;
    badgeId?: number;
    schoolName?: string | null;
    schoolId?: number | null;
    badgeName?: string | null;
    uuid?: string | null;
}

